


document.addEventListener("DOMContentLoaded", function() {
  const wishlistButtons = document.querySelectorAll('.wishlist-btn');

  // Load wishlist
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  wishlistButtons.forEach(button => {
    const productId = button.dataset.id;

    // Show correct heart state on page load
    const isInWishlist = wishlist.some(item => item.id === productId);
    if (isInWishlist) {
      button.classList.add('active');
    }

    button.addEventListener('click', function() {
      const productHandle = this.dataset.handle;
      const productUrl = this.dataset.url;
      const productId = this.dataset.id;
      let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

      const exists = wishlist.find(item => item.id === productId);

      if (!exists) {
        // Add to wishlist
        wishlist.push({ id: productId, handle: productHandle, url: productUrl });
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        this.classList.add('active');
      } else {
        // Remove from wishlist
        wishlist = wishlist.filter(item => item.id !== productId);
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        this.classList.remove('active');
      }
    });
  });
});